export default "__VITE_ASSET__AN82FzYX__"